import { dispatch, state } from '__common/store';
import { getTiltedModuleSizes } from '__editor/panelsEditor/components/tiltedModule/tiltedModule';
import { getPanelSize } from '__editor/panelsEditor/components/panels/panelsHelper';
import { SET_PANELS_WIDTH_AND_HEIGHT } from 'actions';

// UBuilder-Lite-only override of setPanelsDimensions. Normalises on shape
// (Math.min/max) instead of trusting modelData's width/height labels — some
// default Lite modules (SM/NXT) come back with the long side stored as
// `width`, which used to flip the sprite the opposite way of the orientation
// toggle. Routed to from panels.ts:setPanelsDimensions when state().app.isUbuilderLite
// is true; legacy editor keeps the original implementation untouched.
export const setPanelsDimensionsLite = () => {
  const {
    background: { metersPerPixel },
    projectConfiguration: { projectEnvConfig: { tilt } },
    editorCursor: { landscape },
    tiltedRoof: { structureTilt },
  } = state();
  let panelWidth;
  let panelHeight;

  if (metersPerPixel) {
    const { width, height } = (tilt || structureTilt) ? getTiltedModuleSizes() : getPanelSize();
    const shortSide = Math.min(width, height);
    const longSide = Math.max(width, height);
    if (landscape) {
      panelWidth = longSide;
      panelHeight = shortSide;
    } else {
      panelWidth = shortSide;
      panelHeight = longSide;
    }
  }
  if (panelWidth && panelHeight) dispatch(SET_PANELS_WIDTH_AND_HEIGHT(panelWidth, panelHeight));
};
